module.exports = __webpack_public_path__ + "img/upper-box.c6cf8322.svg";